import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Typography, Box, Chip, Grid, TextField, Radio, RadioGroup, FormControlLabel } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { setSelectedProductId } from "store/slice/PharmaSlice";
import {setOrderType} from "store/slice/AppSlice";
import { getCompositiontemplateInfoByTitleAPI } from "components/compositiontemplate/CompositiontemplateAPI";
import {getListAPI as getProductList} from "components/product/ProductAPI";
import {getProductInfoByPartyidAPI} from "components/product/ProductAPI";
import {setSelectedCTid} from "store/slice/AppSlice";
import SelectCompositionTemplate from "components/compositiontemplate/components/SelectCompositionTemplate";
import SelectCompositionTemplateFromRepeatOrder from "components/product/components/SelectCompositionTemplateFromRepeatOrder";

export default function SelectProductOrderType({ sectionHeight }) {
  const dispatch = useDispatch();
  const { productList } = useSelector((state) => state.pharmaslice);
  const { partyObj } = useSelector((state) => state.pharmaslice.partyDashboard);
  const [productId, setProductId] = useState(null);
  const [filter, setFilter] = useState("");
  const {orderType} = useSelector((state) => state.appslice);
  const { compositiontemplateList } = useSelector((state) => state.pharmaslice);
  const [lProductList, sLPoductList] = useState(compositiontemplateList);
  const {userprofileInfo} = useSelector((state) => state.headerslice);
  
  useEffect(() => {
    if (orderType === "REPEAT") {
      
    } else { // In case of NEW order
        if (filter!=='' && filter.length > 2) { 
            getCompositiontemplateInfoByTitleAPI(filter,userprofileInfo.businessid, sLPoductList, (data) => {
            console.log("Composition template list fetched successfully:", data);
            //sLPoductList(data);
          });
        } else {
          sLPoductList([]);
        }
      }
  }, [filter]);

  useEffect(() => {
    if (orderType === "REPEAT") {
      getProductInfoByPartyidAPI(partyObj.id, sLPoductList, () => {});
    }      
  },[orderType]);

  const handleProductClick = (id) => {
    console.log("Selected Product ID:", id);
    dispatch(setSelectedProductId(id));

    // if (orderType === "REPEAT") {
    //   setProductId(id);
    //   if (id === null)
    //     dispatch(setSelectedProductId(-1));
    //   else
    //     dispatch(setSelectedProductId(id));
    // } else {
    //   setProductId(id);
    //   if (id === null)
    //     dispatch(setSelectedCompositiontemplateId(-1));
    //   else
    //     dispatch(setSelectedCompositiontemplateId(id));
    // }
  };
  

  const handleOrderTypeChange = (event) => {
    dispatch(setOrderType(event.target.value));
    if (event.target.value === "REPEAT") {
      sLPoductList(productList);
    } else {
      dispatch(setSelectedProductId(-1));
      sLPoductList(compositiontemplateList);
    }
  };

  return (
    <Grid container direction="row" sx={{ width: '100%', backgroundColor: 'secondary.lighter', }}>
      <Grid lg={12} xs={12} item sx={{ display: "flex", alignItems: "center", justifyContent: "center", }}>
        <Grid container direction="row" alignItems="top" sx={{ width: '100%' }}>
          {/* <Grid item lg={2} xs={12} sx={{ display: "flex", alignItems: "top", justifyContent: "space-between", }}>
            <Grid container direction="column" sx={{ width: '100%', backgroundColor: 'secondary.200', padding: 1, borderRadius: 1 }}>
              <Grid item >
                <Typography variant="h6" sx={{ color: 'primary.darker', fontWeight: 'bold', marginBottom: 1 }}>Order Type</Typography>
              </Grid>
              <Grid item sx={{ backgroundColor: 'white', padding: 1, borderRadius: 1, }}>
                <RadioGroup row value={orderType} onChange={handleOrderTypeChange} sx={{ borderRadius: 1 }}>
                  <FormControlLabel value="NEW" control={<Radio color="primary" />} label="New Order" />
                  <FormControlLabel value="REPEAT" control={<Radio color="primary" />} label="Repeat Order" />
                </RadioGroup>
              </Grid>
            </Grid>
          </Grid> */}
          <Grid item lg={12} xs={12} sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", paddingLeft: 1 }}>
            {orderType === "NEW" ? 
              <SelectCompositionTemplate sectionHeight={{lg:'45vh',  md:'30vh', sm:'30vh', xs:'30vh',  }}/>
            :<>
              <Grid container direction="row" sx={{ width: '100%', backgroundColor: 'secondary.200',  }}>
                
                <Grid item lg={9} md={9} sm={9} xs={12} sx={{ padding: 1, borderRadius: 5, pl: { lg: 1, md: 1, sm: 0, xs: 0 }, mt: { sm: 2, xs: 2, md: 0, lg: 0 } }}>
                    <SelectCompositionTemplate sectionHeight={{lg:'52vh',  md:'35vh', sm:'35vh', xs:'35vh'}} />
                </Grid>
                <Grid item lg={3} md={3} sm={3} xs={12} sx={{padding: 1, borderRadius: 5, pr: { lg: 1, md: 1, sm: 0, xs: 0 } }}>
                    <SelectCompositionTemplateFromRepeatOrder sectionHeight={{lg:'55vh',  md:'40vh', sm:'40vh', xs:'40vh'}} />
                </Grid>
              </Grid>
              
              
            </>}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}